import React, { useState, useEffect } from "react";
import { Row, Col, Form, Button, Container } from "react-bootstrap";
import { Draggable } from "react-beautiful-dnd";
import { v4 as uuidv4 } from "uuid";
import jsDig from "utils/jsDig";

export default function KeywordBox(props) {
  const handleSrc = require("images/icons/ui-handle.png");
  const boxHandle = <img src={`/datapulse${handleSrc}`} className="handle-icon" />;
  const kgGroupId = props.id;
  const [conditions, setConditions] = useState(
    props.conditions
      ? Object.values(props.conditions).map((el) => {
        return (el = [el, uuidv4()]);
      })
      : [[{ contains: "contains", word: "" }, uuidv4()]]
  );
  const handleAddCondition = () => {
    let newCondition = [{ contains: "contains", word: "" }, uuidv4()];
    let newKeywordGroups = props.keywordGroups;
    newKeywordGroups[props.index]["conditions"] = [...props.conditions, { contains: "contains", word: "" }];
    setConditions((conditions) => [...conditions, newCondition]);
    props.setKeywordGroups([...newKeywordGroups]);
  };
  const handleRemoveCondition = (id) => {
    let newKeywordGroups = props.keywordGroups;
    newKeywordGroups[props.index]["conditions"] = conditions.filter((condition) => condition[1] !== id).map((el) => el[0]);
    props.setKeywordGroups([...newKeywordGroups]);
    setConditions(conditions.filter((condition) => condition[1] !== id));
  };

  return (
    <Draggable draggableId={kgGroupId} index={props.index}>
      {(provided) => (
        <div {...provided.draggableProps} ref={provided.innerRef} className="d-flex dark-grey">
          <Container className=" keyword-box" style={{ backgroundColor: "#F5F5F5" }}>
            <Row style={{ height: "inherit" }}>
              <Col
                {...provided.dragHandleProps}
                className="col-1 d-flex justify-content-center handle-container"
                style={{ backgroundColor: "#CACACA", cursor: "grab" }}>
                <div className="my-auto landing-page-group-section-handle">{boxHandle}</div>
              </Col>
              
              <Col style={{ paddingBottom: "15px" }}>
              <div className="seo-config-delete-button">
                <Row className="align-items-center pt-3 pb-2 w-100">
                  <Col xs={10}>
                    <p className="primary f12 p-0 pl-3 m-0">Label</p>
                  </Col>
                  <Col className=" pt-0 pr-1 col-1">
                    {" "}
                    <i className="p-0 fas fa-minus-circle" onClick={() => props.handleDelete(props.id)}></i>
                  </Col>
                   </Row>
                </div>
                <div className="label-blank-bar">
                <Row className="pb-3 pl-2">
                  <input type="hidden" value={props.id} name={`keyword_groups[][id]`} />
                  <Col md={9} xs={9} className="pr-0">
                    {" "}
                    {props.onboarding ? (
                      <Form.Control
                        size="sm"
                        placeholder=""
                        value={props.keywordGroups[props.index] ? props.keywordGroups[props.index]["name"] : ""}
                        onChange={(e) => {
                          let newArray = props.keywordGroups;
                          newArray[props.index]["name"] = e.target.value;
                          props.setKeywordGroups([...newArray]);
                        }}
                      />
                    ) : (
                      <Form.Control size="sm" placeholder="" name={`keyword_groups[][name]`} defaultValue={props.name} />
                    )}
                  </Col>
                </Row>
                </div>
                <Row className="align-items-center pb-2">
                  <Col className="">
                    <p className="primary f12 p-0 pl-3 p-0 m-0">Conditions</p>
                  </Col>
                </Row>
                {conditions.map((el, index) => {
                  console.log(props.conditions);
                  return (
                    <div className = "seo-config-conditions-section">
                     <Row key={el[1]} className="align-items-center pb-2 pl-2">
                     
                      <Col xs={10} className="pr-0">
                      <div className= "d-flex flex-row-reverse justify-content-start">
                        
                          <div style={{marginRight: "-33px" }}> 
                            <i
                            className="p-0 pl-3 fas fa-minus-circle"
                            style={conditions.length == 1 ? { visibility: "hidden" } : {justifyItems: "right-fixed" } }
                            onClick={() => handleRemoveCondition(el[1], index)}></i>
                          </div>
                          <select
                          style={{ width: "100%", paddingLeft: "5px", marginBottom: "10px", fontSize: "smaller" , paddingRight: "-5px", alignItem:"row" }}
                          
                          defaultValue={jsDig(["conditions", index, "contains"], props)}
                          name={`keyword_groups[][conditions][][contains]`}>
                            <option value="contains">Contains</option>
                            <option value="notContains">Not Contains</option>
                        </select>
                        </div> 
                        
                        <div className = "seo-config-conditions" >
                        {props.onboarding ? (
                          <Form.Control
                            size="sm"
                            placeholder=""
                            value={el[0]["word"]}
                            onChange={(e) => {
                              let newArray = props.keywordGroups;
                              console.log(newArray);
                              let newConditions = conditions;
                              newConditions[index][0]["word"] = e.target.value;
                              setConditions([...newConditions]);
                              newArray[props.index]["conditions"][index]["word"] = e.target.value;
                              console.log(newArray);
                              props.setKeywordGroups([...newArray]);
                            }}
                            style={{ marginBottom: "12px" }}
                            />
                          ) : (
                          <Form.Control
                            size="sm"
                            placeholder=""
                            style={{ marginBottom: "20px" }}
                            name={`keyword_groups[][conditions][][word]`}
                            defaultValue={props.conditions[index] !== undefined ? props.conditions[index]["word"] : ""}
                          />
                        )
                        }
                        </div>
                      </Col>
                    </Row>
                    </div>
                    );
                })}
                
                <Button
                  className=" mt-2 ml-md-2 ml-0 btn-full btn-sm py-1"
                  style={{ paddingLeft: "17px", paddingRight: "17px" }}
                  as="input"
                  type="button"
                  value="+ Add keyword phrase"
                  variant="success"
                  onClick={handleAddCondition}
                />
                
              </Col>
            </Row>
          </Container>
        </div>
      )}
    </Draggable>
  );
}
